/**
 * Shared BMS constants
 */

import { BATTERY_TYPE } from './assetConfig';

export const RBMS_PARAMETERS = [
  { key: 'totalVoltage', address: 0x1100, name: 'Total Voltage' },
  { key: 'current', address: 0x1106, name: 'Current' },
  { key: 'soc', address: 0x1107, name: 'SOC' },
  { key: 'soh', address: 0x1108, name: 'SOH' },
  { key: 'maxTemp', address: 0x1109, name: 'Max Temperature' },
  { key: 'minTemp', address: 0x110C, name: 'Min Temperature' },
  { key: 'maxCellVoltage', address: 0x110F, name: 'Max Cell Voltage' },
  { key: 'minCellVoltage', address: 0x1112, name: 'Min Cell Voltage' },
  { key: 'chargeStatus', address: 0x1101, name: 'Charge/Discharge Status' },
  { key: 'systemStatus', address: 0x1102, name: 'System Status' },
  { key: 'alarmEvents', address: 0x1115, name: 'Alarm Events', isFault: true },
  { key: 'primaryProtection', address: 0x1116, name: 'Primary Protection', isFault: true },
  { key: 'secondaryProtection', address: 0x111E, name: 'Secondary Protection', isFault: true },
];

export const DALY_PARAMETERS = [
  { key: 'totalVoltage', address: 0x38, name: 'Total Voltage' },
  { key: 'current', address: 0x39, name: 'Current' },
  { key: 'soc', address: 0x3A, name: 'SOC' },
  { key: 'maxTemp', address: 0x43, name: 'Max Temperature' },
  { key: 'minTemp', address: 0x45, name: 'Min Temperature' },
  { key: 'maxCellVoltage', address: 0x3E, name: 'Max Cell Voltage' },
  { key: 'minCellVoltage', address: 0x40, name: 'Min Cell Voltage' },
  { key: 'chargeStatus', address: 0x48, name: 'Charge/Discharge Status' },
  { key: 'alarmEvents', address: 0x66, name: 'Fault Status 1', isFault: true },
  { key: 'primaryProtection', address: 0x67, name: 'Fault Status 2', isFault: true },
  { key: 'secondaryProtection', address: 0x68, name: 'Fault Status 3', isFault: true },
];

export function getParametersForType(type) {
  if (type === BATTERY_TYPE.DALYLV) {
    return DALY_PARAMETERS;
  }
  return RBMS_PARAMETERS;
}

export function getParamAddress(key, type) {
  const params = getParametersForType(type);
  const param = params.find(p => p.key === key);
  return param ? param.address : undefined;
}

export function unionParameters(types = []) {
  const seen = new Set();
  const result = [];
  const typeList = Array.isArray(types) && types.length > 0 ? types : [BATTERY_TYPE.GCE];
  for (const type of typeList) {
    const params = getParametersForType(type);
    for (const p of params) {
      if (!seen.has(p.key)) {
        seen.add(p.key);
        result.push(p);
      }
    }
  }
  return result;
}

